import Header from "../../Common/header";
import Footer from "../../Common/footer";
import React, { useState, useRef, useEffect } from 'react';
import { getUserSession } from "../../Common/lib/Session";
import { isProjectOwnedByUser } from "../../Common/lib/projectOwnership";
import { API } from "../../Common/lib/api";
import { useParams, useHistory } from "react-router-dom";
import MetadataDisplay from "./metadataDisplay";
import VisualizationPage from "./VisualizationPage/VisualizationPage";

import { useReactToPrint } from "react-to-print";
import {
  HiOutlinePhotograph,
  HiOutlineDocumentText,
  HiOutlinePrinter
} from "react-icons/hi";

const secondaryNavigation = [
  { name: 'Dataset', href: '/profile', icon: HiOutlineDocumentText, componentName: MetadataDisplay, current: true },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function MetaContainer() {
  const [project, setProject] = useState();
  const [isModerator, setIsModerator] = useState(false);
  const [user, setUser] = useState();
  const [currentTab, setCurrentTab] = useState(0);
  const { id } = useParams();
  const printRef = useRef();
  let history = useHistory();

  /**
   * Retrieves the project and checks if the user is a moderator.
   */
  useEffect(() => {
    async function fetchProject() {
      try {
        const projectsQuery = await API.projects.getById(id);
        let project = projectsQuery.data.getProject;

        if (!project) {
          history.push('/');
          return;
        }

        const user = await getUserSession();
        setUser(user);

        const isOwner = isProjectOwnedByUser(project, user);

        if (project.publishStatus !== 'published') {
          if (
            user.success &&
            !isOwner &&
            !user.is_staff
          ) {
            history.push('/');
            return;
          } else if (!user.success) {
            history.push('/');
            return;
          }
        }

        if (user.is_staff) {
          setIsModerator(true);
        }

        let dataVisualization = project.dataVisualization ? JSON.parse(project.dataVisualization) : null;
        if(dataVisualization){
          let visualizations = 0;

          dataVisualization.forEach(visualization => {
            if((visualization.approved && !visualization.archived) || user.is_staff || isOwner){
              visualizations++;
            }
          });

          if(visualizations > 0){
            secondaryNavigation.splice(1, 1, { name: 'Visualization', href: '/contributions', icon: HiOutlinePhotograph, componentName: VisualizationPage, current: false });
          }
        }

        setProject(project);
      } catch(e) {
        console.error('Error fetching project:', e);
        history.push('/');
      }
    }

    if (id) {
      fetchProject();
    }
  }, [id, history]);

  /**
   * Displays current tab component.
   *
   * @returns React Component.
   */
  function renderCurrentTab() {
    const Component = secondaryNavigation[currentTab].componentName;
    return <Component printRef={printRef} project={project} isModerator={isModerator} user={user} />;
  }

  /**
   * Used for printing / saving the main dataset page
   */
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  return (
    <>
      <Header />

      <div className="bg-gray-50 dark:bg-gray-900">
        <div className="mx-auto max-w-7xl lg:flex lg:gap-x-6 lg:px-8">
          <aside className="flex overflow-x-auto border-b border-gray-900/5 py-4 lg:block lg:w-52 lg:flex-none lg:border-0 lg:py-20">
            <nav className="flex-none px-4 sm:px-6 lg:px-0 w-full">
              <ul role="list" className="flex flex-wrap gap-x-3 gap-y-1 lg:flex-col">
                {secondaryNavigation.map((item, index) => (
                  <li key={item.name}>
                    <a
                      data-cy={item.name}
                      onClick={(e) => {
                        setCurrentTab(index);
                      }}
                      className={classNames(
                        index === currentTab
                          ? 'bg-gray-100 text-blue-600 dark:bg-gray-800 dark:text-white'
                          : 'text-gray-700 hover:text-blue-600 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-800',
                        'group flex gap-x-3 rounded-md py-2 pl-2 pr-3 text-sm leading-6 font-semibold'
                      )}
                    >
                      <item.icon
                        className={classNames(
                          index === currentTab ? 'text-blue-600 dark:text-blue-500' : 'text-gray-400 group-hover:text-blue-600 dark:group-hover:text-blue-500',
                          'h-6 w-6 shrink-0'
                        )}
                        aria-hidden="true"
                      />
                      {item.name}
                    </a>
                  </li>
                ))}
                <li>
                  <a
                    onClick={(e) => { handlePrint() }}
                    className="text-gray-700 hover:text-blue-600 hover:bg-gray-100 group flex gap-x-3 rounded-md py-2 pl-2 pr-3 text-sm leading-6 font-semibold dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-800"
                  >
                    <HiOutlinePrinter
                      className="text-gray-400 group-hover:text-blue-600 h-6 w-6 shrink-0 dark:group-hover:text-blue-500"
                      aria-hidden="true"
                    />
                    Print / Save as PDF
                  </a>
                </li>
              </ul>

              {/* DON'T DELETE PLS - Side bar with additional clickable options */}
              {/* <div className="p-2 sm:mt-10 mt-6 w-full">
                <p className="font-medium text-sm border-b border-gray-200 pb-2">
                  Category
                </p>
                <ul>
                  <li>
                    <a
                      onClick={(e) => {
                      }}
                      className="mt-2 text-gray-700 hover:text-blue-600 hover:bg-gray-100 group flex gap-x-3 rounded-md py-2 pl-2 pr-3 text-sm leading-6 font-normal"
                    >
                      Option
                    </a>
                  </li>
                </ul>
              </div>
              <div className="p-2 mt-4 w-full">
                <p className="font-medium text-sm border-b border-gray-200 pb-2">
                  Category
                </p>
                <ul>
                  <li>
                    <a
                      onClick={(e) => {
                      }}
                      className="mt-2 text-gray-700 hover:text-blue-600 hover:bg-gray-100 group flex gap-x-3 rounded-md py-2 pl-2 pr-3 text-sm leading-6 font-normal"
                    >
                      Option
                    </a>
                  </li>
                </ul>
              </div> */}
            </nav>
          </aside>

          <main className="px-4 py-12 sm:px-6 lg:flex-auto lg:px-0 lg:py-20">
            {renderCurrentTab()}
          </main>
        </div>
      </div>

      <Footer />
    </>
  );
};